import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MitsTableButton } from '../mits-table/interfaces/mits-table-button';

@Component({
  selector: 'mits-buttons-popover',
  templateUrl: './mits-buttons.popover.html',
  styleUrls: ['./mits-buttons.popover.scss'],
})
export class MitsButtonsPopover implements AfterViewInit {
  /** All buttons wich should be displayed */
  @Input() buttons: MitsTableButton<any>[];
  /** Set the target-size of the popover (if enough place is on screen this will be the max. size) */
  @Input() targetSize: { width: number; height: number };
  /** Index of the optionalData in an array */
  @Input() indexOptionalData: number;
  /** optionalData for the displaying buttons to work with */
  @Input() optionalData: any;
  /** Emits if button gets "selected" / clicked */
  @Output() onSelect: EventEmitter<MitsTableButton<any>> = new EventEmitter();

  /** Is the buttons popover currently open? */
  opened = false;
  /** Last/Current position of the popover */
  position: {
    x: number;
    y: number;
  };
  /** Last/Current size of the popover */
  size: {
    w: number;
    h: number;
  } = { w: 160, h: 80 };

  /** Element of the Backdrop */
  @ViewChild('popoverBackdrop')
  popoverBackdropElement: ElementRef<HTMLSpanElement>;
  /** Element of the Wrapper */
  @ViewChild('popoverWrapper')
  popoverWrapperElement: ElementRef<HTMLSpanElement>;

  ngAfterViewInit(): void {
    const newParent = document.getElementsByTagName('html')[0];
    newParent.appendChild(this.popoverBackdropElement.nativeElement);
  }

  clicked(event: Event, button: MitsTableButton<any>, index: number) {
    if (
      button.disabled ||
      (button.disabledFunc && button.disabledFunc(this.optionalData))
    )
      return;
    button.handler({
      event,
      indexOptionalData: this.indexOptionalData,
      itemOptionalData: this.optionalData,
      index,
    });
    this.onSelect.emit(button);
  }

  /**
   * Toggles the popover
   * @param ev Event of the click
   */
  toggle(ev: any): void {
    if (ev && !this.opened) {
      const areaX = this.getAreaOnAxis(
        ev.pageX,
        this.targetSize?.width || this.size.w,
        this.popoverBackdropElement.nativeElement.clientWidth,
        false
      );
      const areaY = this.getAreaOnAxis(
        ev.pageY,
        this.targetSize?.height || this.size.h,
        this.popoverBackdropElement.nativeElement.clientHeight,
        true
      );
      this.size = {
        w: areaX.s,
        h: areaY.s,
      };
      this.position = {
        x: areaX.p,
        y: areaY.p,
      };
    }
    if (this.position) {
      this.popoverWrapperElement.nativeElement.style.left =
        this.position.x.toString() + 'px';
      this.popoverWrapperElement.nativeElement.style.top =
        this.position.y.toString() + 'px';
    }
    this.opened = !this.opened;
  }

  /**
   * Returns the optimal position on an axis based on parameters
   * @param tp Target position
   * @param ts Target size
   * @param ms Max size of placeable area
   * @param center should the area be centered?
   * @returns Optimal position and size on axis in pixels
   */
  private getAreaOnAxis(
    tp: number,
    ts: number,
    ms: number,
    center: boolean
  ): { p: number; s: number } {
    const freeSpaceBefore = tp;
    if (center) {
      const missalignedPos = tp + ts / 2 > ms ? ms - ts : tp - ts / 2;
      return {
        p: tp - ts / 2 < 0 ? 0 : missalignedPos,
        s: ts,
      };
    }
    if (ms - freeSpaceBefore >= ts) {
      return { p: tp, s: ts };
    } else if (freeSpaceBefore >= ts) {
      return { p: tp - ts, s: ts };
    }
  }
}
